import { mount } from "svelte";
import App from "./App.svelte";
import Gate from "./Gate.svelte";

mount(localStorage.getItem("gday") === "ok" ? App : Gate, { target: document.body });
